import { HttpException } from '../../../../exceptions/index';

/**
 * Did a rejected termination batch already commit some of its stakeholders?
 *
 * The backend commits one stakeholder per transaction, so a payload rejected partway through
 * leaves the earlier ones terminated. `StakeholdersService.toPartialBatchError` reports that by
 * putting the committed ids on the error body — read structurally rather than by matching the
 * English sentence it also puts in `message`, which is a toast string and free to change.
 *
 * Conservative on purpose: anything that is not a populated array of ids reads as "nothing
 * committed", so an unrecognised error shape leaves the modal open rather than discarding the
 * operator's typed-in figures.
 */
export const hasPartiallyTerminated = (error: unknown): boolean => {
  if (!(error instanceof HttpException)) return false;

  const { terminatedStakeholderIds } = error.body;

  return Array.isArray(terminatedStakeholderIds) && terminatedStakeholderIds.length > 0;
};
